import { render, staticRenderFns } from "./FpssWizard.vue?vue&type=template&id=38171f6b&scoped=true"
import script from "./FpssWizard.vue?vue&type=script&lang=js"
export * from "./FpssWizard.vue?vue&type=script&lang=js"
import style0 from "./FpssWizard.vue?vue&type=style&index=0&id=38171f6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38171f6b",
  null
  
)

export default component.exports